import React from 'react'
import { Card, CardHeader, CardTitle, CardBody } from '../../../Card'
import { Icon } from '../../../../atoms/Icon'
import type { LandLinksProps } from '../../LandSection.types'
import { LinksContainer, LinkButton, LinkLabel } from './LandLinks.styles'

export const LandLinks: React.FC<LandLinksProps> = ({
  landId,
  latitude,
  longitude,
  className,
  t,
}) => {
  const exploreUrl = React.useMemo(() => {
    if (!latitude || !longitude) {
      console.warn('LandLinks: Missing coordinates', {
        latitude,
        longitude,
        landId,
      })
      return null
    }
    return `/developer-map?mode=plot&lat=${latitude}&lon=${longitude}&zoom=17&landId=${landId}`
  }, [landId, latitude, longitude])

  const analysisUrl = `/land-analysis/${landId}`

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{t('links.title')}</CardTitle>
      </CardHeader>
      <CardBody>
        <LinksContainer>
          {exploreUrl && (
            <LinkButton
              href={exploreUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="map" size="small" />
              <LinkLabel>{t('links.viewInExplore')}</LinkLabel>
              <Icon name="arrow-right" size="small" />
            </LinkButton>
          )}

          <LinkButton
            href={analysisUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="file-text" size="small" />
            <LinkLabel>{t('links.openLandAnalysis')}</LinkLabel>
            <Icon name="arrow-right" size="small" />
          </LinkButton>
        </LinksContainer>
      </CardBody>
    </Card>
  )
}
